// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3Py8T","title":"AfterFrontImage_title__2H9C7"};